/**
 * @title: 二联面单模板
 * @author: lorry
 * @time: 2020-01-08
 */
const img = [
  { href: require('@/assets/images/shou.png') },
  { href: require('@/assets/images/ji.png') },
  { href: require('@/assets/images/gongzhonghao.png') },
  { href: require('@/assets/images/bao.png') },
]

export function twoLinkPage(options, index, length, dayObj, $lang) {
  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8">
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta http-equiv="X-UA-Compatible" content="ie=edge">
      <title>Document</title>
      <style>
      html{
        font-family: "黑体";
      }
    .preview {
      margin-left: 30px;
    }
    
    .viewer-pdf-toolbar {
      width: 300px;
    }
    
    #demoContainer {
      width: 380px;
      background: #fff;
      float: left;
      margin-right: 40px;
    }
    
    .pdfDom {
      width: 380px;
      height: 680px;
      margin-right: 30px;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
    }
    .pdfDom .top-bar {
      height: 60px;
      border-bottom: 1px dashed #000;
      position: relative;
    }
  
    .top-bar-right{
      display: ${options.codNeed === 1 ? 'block' : 'none'};
      height:28px;
      line-height:25px;
      letter-spacing:2px;
      position:absolute;
      right:20px;
      width: 84px;
      top:10px;
      text-align:center;
      background: #000;
      font-size: 14px;
      color:#fff;
      font-weight:bold;
    }
    .top-bar-right1{
      display: ${options.totalFreight && options.codNeed !== 1 ? 'block' : 'none'};
      letter-spacing: 4px;
      font-size: 16px;
      color:#fff;
      font-weight:bold;
      position:absolute;
      right:33px;
      background: #000;
      top:15px;
      text-align:center;
      height:22px;
      width: 50px;
      padding:4px 6px 0;
    }
    .top-bar-right2{
      display: ${options.signReceipt === 1 ? 'block' : 'none'};
      height:28px;
      line-height:25px;
      letter-spacing:2px;
      width: 76px;
      padding:2px 5px;
      position:absolute;
      right:23px;
      top:7px;
      text-align:center;
      background: #000;
      font-size: 16px;
      color:#fff;
      font-weight:bold;
  }
    .pdfDom .top-bar #barcode {
      position: absolute;
      top: 10px;
      right: 40px;
    }
    .pdfDom .bottom-bar {
      height: 60px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .pdfDom .qr-type {
      height: 36px;
      border-top: 1px dashed #000;
      border-bottom: 1px dashed #000;
      overflow:hidden;
    }
    .pdfDom .qr-type  .type-code{
      float:left;
      font-size:30px;
      width:290px;
      font-weight:bold;
      text-align:center;
      line-height:36px;
    }
    .pdfDom .qr-type .slt-state-code{
      width: 190px;
      padding-left: 18px;
      line-height: 28px;
      float:left;
    }
    .pdfDom .qr-type .centre {
      border: 2px solid #333;
      display: inline-block;
      font-size: 12px;
      margin-right: 12px;
      text-align: center;
      line-height: 16px;
      width: 16px;
      height: 16px;
    }
    .pdfDom .qr-type .type-name {
      width: 49px;
      height:38px;
      border-left: 1px dashed #000;
      font-size: 13px;
      text-align: center;
    }
    .type-namei{
      padding: 4px 8px 0;
      font-weight:bold;
    }
    .pdfDom .qr-type .type-time {
      border-left: 1px dashed #000;
      font-size: 12px;
      padding: 4px 10px 0;
      overflow:hidden;
    }
    .pdfDom .qr-type .type-time .print-time{
      padding-top: 2px;
      // float:left;
    }
    .pdfDom .qr-code {
      height: 60px;
      padding-left:10px;
      margin-right: 5px;
      border-top: 1px dashed #000;
      font-size: 12px;
      tran
    }
    .pdfDom .qr-code .qr-img {
      width: 55px;
      height: 55px;
      margin-top:3px;
      margin-right:10px;
      float:right;
    }
    .pdfDom .good-msg {
      height: 44px;
      border-bottom:1px dashed #000;
    }
    .pdfDom .good-msg .good-msg-left{
      height: 38px;
      padding-top:6px;
      width: 55px;
      float: left;
      border-right: 1px dashed #000;
    }
    .bao {
      display:${options.insured ? 'block' : 'none'};
      height: 24px;
      width: 24px;
      margin-left:15px;
    }
    .pdfDom .good-msg .good-msg-right{
      height: 44px;
      float: left;
    }
    .good-msg-right ul{
      overflow: hidden;
      list-style: none;
      margin: 0;
      font-size: 12px;
      padding-left: 0;
    }
    .good-msg-right ul.top-one{
      border-bottom:1px dashed #000;
    }
    .good-msg-right li{
      float: left;
      width: 105px;
      text-align: center;
      height: 22px;
      line-height: 22px;
      border-right: 1px dashed #000;
    }
    .good-msg-right ul li.last{
      border:0;
    }
  
    .scd-address {
      width: 100%;
      box-sizing: border-box;
      position:relative;
    }
    .scd-address-bg{
      position:absolute;
      height:150px;
      width:200px;
      top:76px;
      left:70px;
    }
    .scd-address-bg .code-img{
      display:${options.dataUrl ? 'block' : 'none'};
    }
    .scd-address .scdw-list {
      border-bottom: 1px dashed #000;
      height: 52px;
      color: #333;
      overflow:hidden;
    }
    .scd-address .scdw-list .slt-state {
      width: 55px;
      height:50px;
      border-right: 1px dashed #000;
      padding-top:8px;
      float:left;
    }
    .scd-address .scdw-list .slt-state img {
      width: 18px;
      height: 18px;
      margin-left:18px;
    }
    .scd-address .scdw-list .privacy{
        font-weight: bold;
        box-sizing: border-box;
        padding: 2px 10px;
        font-size: 10px;
        background: #000;
        color: #fff;
        display:${options.isPrivacy === 1 ? 'block' : 'none'};
    }
    .scd-address .scdw-list .privacy .number{
        font-size: 12px;
    }
    .scd-address .scdw-list .privacy .call{
        margin-left:50px
    }
    .scd-address .scdw-list .slt-state .shou-img{
      width: 32px;
      height: 32px;
      margin-left:12px;
    }
    .scd-address .scdw-list .sl-top {
      padding-left: 2px;
      padding-top: 2px;
      font-size: 12px;
      float:left;
      width:320px;
    }
    .scd-address .scdw-list .sl-top .slt-info{
      overflow:hidden;
      line-height:15px;
      height:20px;
      font-size: 12px;
    }
    .scd-address .scdw-list .sl-top .slt-info .slti-name {
      padding-right: 2px;
      display:block;
      width:93px;
      float:left;
      overflow:hidden;
    }
    .scd-address .scdw-list .sl-top .slt-info .slti-num {
      display:block;
      float:left;
      width:104px;
    }
    .scd-address .scdw-list .sl-top .slt-info .slti-company {
      margin-left:3px;
      display:block;
      float:left;
      width:118px;
    }
    .scd-address .scdw-shou {
      height: 60px;
    }
    .scd-address .scdw-shou .sl-top {
      font-size: 10px;
      font-weight:bold;
    }
    .f {
      display: inline-block;
      width: 100px;
      height: 70px;
      background: #ccc;
    }
    .remark{
      padding: 5px 10px;
      position:relative;
      height: 68px;
      font-size:10px;
    }
    .remark .checked-txt{
      border: 1px solid #000;
      padding: 2px;
      font-size: 10px;
      position: absolute;
      right:10px;
      bottom: 0px;
    }
    .fr {
      float: right;
    }
      </style>
    </head>
    <body>
     <div class="clearfix fl" id="demoContainer" >
        <div class="fl pdfDom">
          <div class="top-bar">
            <div class="top-bar-right">
              ${$lang('代收货款')}
            </div>
           <div class="top-bar-right1">
              ${$lang('到付')}
            </div>
            <div class="top-bar-right2">
            ${$lang('签单返还')}
            </div>
          </div>
          <div class="qr-type">
            <div class="type-code">${options.terminalDispatchCode ? options.terminalDispatchCode : ''}</div>
            ${options.isBusiness === 1 ? '' : `<div class="fr type-name">
              <div class="type-namei">
              ${options.expressTypeName}
           </div>           
          </div>`}
          </div>
          <div class="qr-type">
            <div class="slt-state">
              <div class="slt-state-code">
                ${options.lastCenterName ? `<span class="centre">${$lang('集')}</span> ${options.lastCenterName}` : ''}
              <!-- 集 -->
              </div>
            </div>
            <div class="fr type-time" >
              <div class="print-time">${$lang('打印时间')}:${dayObj.day}</div>
              <div class="print-time"> 
                <div>${dayObj.hour}  ${index}/${length}</div>
              </div>
            </div>
          </div>
          <!-- 寄件信息 -->
          <div class="scd-address">
            <div class="scd-address-bg">
              <img class="code-img" src="${options.dataUrl}">
            </div>
            <div class="scdw-list scdw-shou">
              <div class="privacy">${$lang('隐私保护')} <span class="call">${$lang('联系收件人请拨打')}: <span class="number">${options.secrecyNo}</span></span></div>
              <div class="slt-state">
                <img class="shou-img" src="${img[0].href}" alt="">
              </div>
              <div class="sl-top">
                <div class="slt-info">
                  <span class="slti-name" style="overflow:hidden;">${options.receiverName}</span>
                  <span class="slti-num" style="overflow:hidden;">${options.receiverMobilePhone || options.receiverTelphone}</span>
                  <span class="slti-company"  style="overflow:hidden;height:15px;">${options.receiverCompany}</span>
                </div>
                <div style="overflow:hidden;height:30px;line-height:11px;">${options.receiverProvinceName}${options.receiverCityName}${options.receiverAreaName}${options.receiverDetailedAddress}</div>
              </div>
            </div>
            <div class="scdw-list">
              <div class="slt-state">
                <img src="${img[1].href}" alt="">
              </div>
              <div class="sl-top">
                <div class="slt-info">
                  <span class="slti-name" style="overflow:hidden;">${options.senderName}</span>
                  <span class="slti-num" style="overflow:hidden;">${options.senderMobilePhone || options.senderTelphone}</span>
                  <span class="slti-company"  style="overflow:hidden;height:20px;">${options.senderCompany}</span>
                </div>
                <div style="overflow:hidden;height:8mm;line-height:16px;">${options.senderProvinceName}${options.senderCityName}${options.senderAreaName}${options.senderDetailedAddress}</div>
              </div>
            </div>
          </div>
          <div class="good-msg">
            <div class="good-msg-left">
              <img class="bao" src="${img[3].href}" alt="">
            </div>
            <div class="good-msg-right">
              <ul class="top-one">
                <li>${$lang('代收货款')}</li>
                <li>${$lang('到付运费')}</li>
                <li class="last">${$lang('寄件重量')}</li>
              </ul>
              <ul>
                <li>${options.codMoneyTag}</li>
                <li>${options.totalFreight ? options.currencySymbol + options.totalFreight : ''}</li>
                <li class="last">${options.packageChargeWeight ? options.packageChargeWeight + 'KG' : ''}</li>
              </ul>
            </div>
          </div>
          <div class="bottom-bar">
          </div>
          <div class="qr-code">
             <img class="qr-img" src="${img[2].href}" alt="">
          </div>
          <div class="top-bar">
          </div>
          <!-- 寄件信息 -->
          <div class="scd-address">
            <div class="scdw-list scdw-shou">
              <div class="privacy">${$lang('隐私保护')} <span class="call">${$lang('联系收件人请拨打')}: <span class="number">${options.secrecyNo}</span></span></div>
              <div class="slt-state">
                <img class="shou-img" src="${img[0].href}" alt="">
              </div>
              <div class="sl-top">
                <div class="slt-info">
                  <span class="slti-name" style="overflow:hidden;">${options.receiverName}</span>
                  <span class="slti-num" style="overflow:hidden;">${options.receiverMobilePhone || options.receiverTelphone}</span>
                  <span class="slti-company"  style="overflow:hidden;height:20px;">${options.receiverCompany}</span>
                </div>
                <div style="overflow:hidden;height:30px;line-height:11px;">${options.receiverProvinceName}${options.receiverCityName}${options.receiverAreaName}${options.receiverDetailedAddress}</div>
              </div>
            </div>
            <div class="scdw-list">
              <div class="slt-state">
                <img src="${img[1].href}" alt="">
              </div>
              <div class="sl-top">
                <div class="slt-info">
                  <span class="slti-name" style="overflow:hidden;">${options.senderName}</span>
                  <span class="slti-num" style="overflow:hidden;">${options.senderMobilePhone || options.senderTelphone}</span>
                  <span class="slti-company" style="overflow:hidden;height:20px;">${options.senderCompany}</span>
                </div>
                <div style="overflow:hidden;height:8mm;line-height:16px;">${options.senderProvinceName}${options.senderCityName}${options.senderAreaName}${options.senderDetailedAddress}</div>
              </div>
            </div>
          </div>
          <!-- 寄件 -->
          <div class="remark" style="overflow:hidden;line-height:14px;">
          ${$lang('备注')}：${options.remarks}
          <div class="checked-txt">${$lang('已检视')}</div>
          </div>
        </div>
      </div>
    </body>
    </html>`
}

